import { render, staticRenderFns } from "./CompanyOmsIndex.vue?vue&type=template&id=25b1f48d&scoped=true&"
import script from "./CompanyOmsIndex.vue?vue&type=script&lang=js&"
export * from "./CompanyOmsIndex.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOmsIndex.vue?vue&type=style&index=0&id=25b1f48d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b1f48d",
  null
  
)

export default component.exports